var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9611 36.4952L31.2985 4.02687C28.4607 -0.750573 21.5431 -0.756921 18.7015 4.02687L1.03973 36.4952C-1.86124 41.377 1.65097 47.5588 7.3368 47.5588H42.6626C48.3436 47.5588 51.8621 41.3819 48.9611 36.4952ZM25 41.6994C23.3849 41.6994 22.0703 40.3848 22.0703 38.7697C22.0703 37.1547 23.3849 35.84 25 35.84C26.615 35.84 27.9297 37.1547 27.9297 38.7697C27.9297 40.3848 26.615 41.6994 25 41.6994ZM27.9297 29.9807C27.9297 31.5957 26.615 32.9104 25 32.9104C23.3849 32.9104 22.0703 31.5957 22.0703 29.9807V15.3322C22.0703 13.7172 23.3849 12.4026 25 12.4026C26.615 12.4026 27.9297 13.7172 27.9297 15.3322V29.9807Z",
    fill: "#FF6750"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWarning);
export default __webpack_public_path__ + "static/media/deleteWarning.34048e53b1d549ad034c112a87aaae94.svg";
export { ForwardRef as ReactComponent };